
export class LanguageText {
    text: string;
    shortCode: string;
    
    constructor(text: string){
        this.text = text;
    }
    
}

export class LanguagesTexts extends Array<LanguageText> {
    constructor(languagesTexts: Array<any>){
        super();
        if(languagesTexts){
            for(let languageText of languagesTexts){
                this.push({
                    text: languageText.text,
                    shortCode: languageText.language.shortCode
                });
            }
        }
    }
    
    getText(shortCode: string): string {
        return this.find(l => l.shortCode === shortCode)?.text || '';
    }
}